/** @module SiteAdmin/Lookup/CopyLookupItem */
define([
	"dojo/_base/declare",
	"csi/reflection",
	"csi/table/Copy"
], function(declare,reflection,Copy) {

	return declare(Copy, {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: fix type based on switchboard
			view.setFieldDisabled(reflection.ATTR_SUBTYPE, true);
			this.inherited(arguments);
		}
	});
});